<template>
  <v-row>
    <v-col cols="6">
      <v-text-field v-model="data.first_name" label="First Name"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.last_name" label="Last Name"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.address" label="Address"></v-text-field>
    </v-col>
    <v-col cols="6">
      <!-- <v-text-field v-model="data.role" label="Role"></v-text-field> -->
      <select-roles v-model="data.role"></select-roles>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.mobile" label="Mobile"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.telephone" label="Telephone"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.email" label="Email"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.password" label="Password"></v-text-field>
    </v-col>

    <v-col cols="6">
      <date-picker v-model="data.start_date" label="Start Date"></date-picker>
    </v-col>
    <v-col cols="6">
      <date-picker v-model="data.end_date" label="End Date"></date-picker>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.bank_name" label="Bank Name"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field
        v-model="data.account_name"
        label="Account Name"
      ></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.bsb_number" label="BSB Number"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field
        v-model="data.account_number"
        label="Account Number"
      ></v-text-field>
    </v-col>
    <v-col cols="6">
      <date-picker
        v-model="data.date_of_birth"
        label="Date Of Birth"
      ></date-picker>
    </v-col>
    <v-col cols="6">
      <v-text-field
        v-model="data.emergency_contact"
        label="Emergency Contact"
      ></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-textarea v-model="data.notes" label="Notes"></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
import { Strings } from '../../../utils'
import DatePicker from '../../../components/DatePicker'
import SelectRoles from '../../../components/SelectRoles'
export default {
  name: 'EmployeeForm',
  props: ['data'],
  components: { DatePicker, SelectRoles },

  data() {
    return {
      icons: ['mdi-rewind', '', 'mdi-fast-forward'],
      baseUrl: Strings.baseUrl,
      deleteFileLoading: false
    }
  },
  methods: {}
}
</script>

<style scoped></style>
